import { ControlledSelect } from "@dune/ui";
import { gfaProcessesTypeToStringMap } from "@dune/vars";
import { useFormContext } from "react-hook-form";

const GFAProcessesTypeContainer = () => {
	const { control } = useFormContext();
	return (
		<div className="border-solid border-1 border-gray-200 rounded-lg p-4 space-y-4 relative">
			<div className="flex flex-row gap-4">
				<ControlledSelect
					name={"processesType"}
					control={control}
					label={"Procédés constructifs"}
					options={Object.entries(gfaProcessesTypeToStringMap).map(
						([key, value]) => ({
							label: value,
							value: key,
						}),
					)}
				/>
			</div>
		</div>
	);
};

export default GFAProcessesTypeContainer;
